import { useServiceError } from '@/hooks';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  calculateItemTaxes,
  deleteMultipleInvoiceItems,
  listInvoiceItem,
  updateInvoiceItemCfop,
  updateInvoiceItemRate,
  updateInvoiceItemTaxes,
} from './invoiceItem.service';
import { PageRequest } from '@/core/request/PageRequest';
import { DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useListInvoiceItem(
  params: PageRequest & { invoiceId?: number },
) {
  return useQuery(
    ['invoiceItems', { ...params }],
    () => {
      const queryParams = {
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listInvoiceItem(queryParams);
    },
    {
      enabled: !!params?.invoiceId,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useUpdateInvoiceItemCfop() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: { invoiceId: number; cfopId?: number }) => updateInvoiceItemCfop(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['invoiceItems']);
      },
      onError(error) {
        notificationError(error);
      },
    },
  );

  return mutation;
}

export function useUpdateInvoiceItemRate() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation(
    (obj: { invoiceId: number; rate?: number }) => updateInvoiceItemRate(obj),
    {
      async onSuccess() {
        notification.success({
          message: 'Atualizado valor de alíquota',
        });
        queryChanel({
          invalidateQueries: [['invoiceItems']],
        });
      },
      onError(error) {
        notificationError(error);
      },
    },
  );

  return mutation;
}

export function useUpdateInvoiceItemTaxes() {
  const queryClient = useQueryClient();

  return useMutation(updateInvoiceItemTaxes, {
    async onSuccess() {
      notification.success({
        message: 'Tributos dos itens atualizados',
      });
      await queryClient.invalidateQueries(['invoiceItems']);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCalcTaxesItems() {
  const queryClient = useQueryClient();

  const mutation = useMutation((id?: number) => calculateItemTaxes(id), {
    async onSuccess(_, itemId) {
      notification.success({
        message: 'Sucesso',
        description: 'Tributos dos itens calculados com sucesso',
      });

      await queryClient.invalidateQueries(['invoice-items', itemId]);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteMultipleInvoiceItems() {
  const queryChanel = useQueryChanel();

  return useMutation(deleteMultipleInvoiceItems, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Serviços da Nota Fiscal removidos com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['invoiceItems']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
